import axios from 'axios'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 5000,
  headers: {
    'Client-APPID': 'WXP_voiceSoft_PC_beta',
    'Client-Version': '1.0.1',
    'content-type': 'application/json',
  }
})

// 请求拦截器
service.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Access-Token'] = `${token}`
  }
  return config
})

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.data.msg == '请求认证未通过' && !response.data.result) {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      router.push('/login')
    }
    return response
  },
  error => {
    if (error.response?.status === 401) {
      // token过期或无效
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

export default service 